<template>
  <popup-modal ref="popup">
    <DialogCloseButton :close-method="closeDialog" />

    <h2 class="text-center font-weight-bold mb-4">
      {{ $t('FILE_STEP_BREAKDOWN.PRODUCT_QUESTION_MODAL.TITLE') }}
    </h2>
    <div class="subtitle mb-4">
      {{
        $t('FILE_STEP_BREAKDOWN.PRODUCT_QUESTION_MODAL.SUBTITLE') +
        ' ' +
        productBreakdownDescription
      }}
    </div>
    <v-row class="mb-4">
      <v-col
        v-for="(product_question, index) of product_questions"
        :key="product_question.id"
        :cols="product_questions.length === 1 ? 12 : 6"
      >
        <v-img
          class="dialog-picture-content mb-4"
          :src="product_question.picture"
          alt="Product Question Preview"
        />
        <p class="font-weight-bold mb-4 text">
          {{
            $t('FILE_STEP_BREAKDOWN.PRODUCT_QUESTION_MODAL.TEST_' + (index + 1)) +
            ' ' +
            product_question.question
          }}
        </p>
        <v-radio-group v-model="product_question.answer">
          <v-radio
            color="#559a1b"
            :label="product_question.option_one"
            :value="product_question.option_one"
          />
          <v-radio
            color="#559a1b"
            :label="product_question.option_two"
            :value="product_question.option_two"
          />
        </v-radio-group>
      </v-col>
    </v-row>

    <v-btn class="boom-button" variant="outlined" @click="_confirm">
      {{ validateButton }}
    </v-btn>
  </popup-modal>
</template>

<script>
import PopupModal from './PopupModal.vue'
import ProductQuestionService from '@/services/ProductQuestionService'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'

export default {
  name: 'ProductQuestionModal',
  components: { DialogCloseButton, PopupModal },
  data: () => ({
    productBreakdownId: undefined,
    productBreakdownDescription: undefined,
    validateButton: undefined,
    resolvePromise: undefined,
    rejectPromise: undefined,
    product_questions: []
  }),
  methods: {
    async show(opts = {}) {
      this.productBreakdownId = opts.productBreakdownId
      this.productBreakdownDescription = opts.productBreakdownDescription
      this.validateButton = opts.validateButton

      await this.getProductQuestion()

      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm() {
      this.$refs.popup.close()

      const formattedValue = []
      this.product_questions.forEach((product_question) => {
        formattedValue.push({
          breakdown_question_boomerang_id: product_question.boomerang_id,
          breakdown_question_answer: product_question.answer
        })
      })

      this.resolvePromise(formattedValue)
    },
    closeDialog() {
      this.$refs.popup.close()
    },
    async getProductQuestion() {
      const responseProductQuestion = await ProductQuestionService.getProductQuestionList(
        this.productBreakdownId
      )
      this.product_questions = responseProductQuestion.item_list
      this.product_questions.map((product_question) => (product_question.answer = 'N/A'))
    }
  }
}
</script>

<style scoped>
.subtitle {
  margin: 0 auto;
  border: 1px solid black;
  padding: 5px 25px;
  background-color: #efefef;
  color: black;
  text-align: center;
  border-radius: 10px;
  width: fit-content;
}

.dialog-picture-content {
  width: 50%;
  height: 150px;
  margin: auto;
}

.boom-button {
  margin: 0 auto;
}

.text {
  word-wrap: break-word;
}
</style>
